import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '@mdi/react';
import {
  mdiClipboardPlay,
  mdiAccountMultiplePlus,
  mdiShieldKey,
} from '@mdi/js';

export default function RegisterParents() {
  return (
    <div className='my-5 pt-1'>
      <span className='flex justify-between align-start has-text-link is-italic hand-pointer pr-2'>
        <Link to='/forget-password'>
          <div
            className='is-size-7 is-link is-small flex justify-start align-center hand-pointer px-2 py-1'
            style={{ width: 'max-content', borderRadius: 25 }}
          >
            <Icon path={mdiShieldKey} size={0.65} color={'#495fc7'} />
            <span className='ml-1'>Forget Password</span>
          </div>
        </Link>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: 6,
          }}
        >
          <Link to='/register'>
            <div
              className='is-size-7 is-link flex justify-end align-center hand-pointer px-2 py-1'
              style={{ width: 'max-content', borderRadius: 25 }}
            >
              <Icon
                path={mdiAccountMultiplePlus}
                size={0.65}
                color={'#495fc7'}
              />
              <span className='ml-1'>Register Ortu/Wali</span>
            </div>
          </Link>
          <Link to='/tutorial-install-portal-aplikasi-android'>
            <div
              className='is-size-7 is-link flex justify-end align-center hand-pointer px-2 py-1'
              style={{ width: 'max-content', borderRadius: 25 }}
            >
              <Icon path={mdiClipboardPlay} size={0.65} color={'#495fc7'} />
              <span className='ml-1'>Install Aplikasi</span>
            </div>
          </Link>
        </div>
      </span>
    </div>
  );
}
